// extracted by mini-css-extract-plugin
export default {"textClassName":"_3W0PN","circleClassName":"oJXH4","regionClassName":"_1Qo8U"};